<template>
  <form v-if="!preventBind" class="w-m-content financeiro-window"> <!--  @submit.prevent="save" -->
    <div class="w-m-header">
      <p class="font-14 font-bold no-margin no-select" style="color: #293e52">Novo {{ label }}</p>
      <div class="m-b-xs m-t-xs" v-if="entidade">
        Registro relacionada à entidade <span class="capitalize">{{ entidade }}</span> com ID {{ entidadeId }}
      </div>
      <div class="m-b-xs m-t-xs" v-if="tags">
        <span v-if="tags && tags.length">Tag(s): {{tags.join(', ')}}</span><span v-else>Tag: {{tags}}</span>
      </div>
    </div>
    <div class="w-m-body e-input-modern label-size-2 size1 fin-form">
      <e-row>
        <e-col style="padding-right: 20px">
          <e-row mr>
            <e-col>
              <erp-s-field label="Descrição">
                <erp-input autofocus :placeholder="'Defina um nome para seu ' + label.toLowerCase()" v-model="conta.descricao"/>
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row mr>
            <e-col>
              <erp-s-field label="Categoria">
                <!--                <categoria-input v-model="conta.categoria"/>-->
                <categoria-hirerarquia-select :tipo="tipoInt" v-model="conta.categoria" />
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row class="m-t" mr>
            <e-col>
              <erp-s-field label="Conta">
                <banco-input v-model="conta.conta"/>
              </erp-s-field>
            </e-col>
            <e-col>
              <erp-s-field label="Data competência">
                <datetime-input input-class="app-input" date-type="date" date-format="##/##/####"
                                v-model.lazy="conta.dataCompetencia"
                                simpleBorder/>
              </erp-s-field>
            </e-col>
            <e-col>
              <erp-s-field label="Data vencimento">
                <datetime-input input-class="app-input" date-type="date" date-format="##/##/####"
                                v-model.lazy="conta.dataVencimento"
                                simpleBorder/>
              </erp-s-field>
            </e-col>
            <e-col>
              <erp-s-field label="Valor">
                <erp-input placeholder="R$" v-model.lazy="conta.valor" v-money="money"/>
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row mr>
            <e-col style="max-width: 154px" class="flex items-center">
              <erp-s-field label="Dedutível?">
                <erp-select v-model="conta.dedutivel" :options="[
                {label: 'Sim', value: true},
                {label: 'Não', value: false},
            ]" />
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row class="m-t m-b" mr>
            <e-col>
              <div style="border-top: #CCCCCC 1px solid"></div>
            </e-col>
          </e-row>
          <e-row mr>
            <e-col class="flex items-center">
              <label for="repetir" class="no-select font-12 flex items-center">
                <input type="checkbox" v-model="conta.repetir" id="repetir">
                <span class="m-l-xs">Repetir</span>
              </label>
            </e-col>
          </e-row>
          <e-row mr>
            <e-col class="flex items-center">
              <erp-select :disable="!conta.repetir" :options="repetirTypes" v-model="conta.repetirIntervalo"
                          style="max-width: 200px"/>
              <span class="m-l-lg m-r">Ocorrências</span>
              <erp-input :disable="!conta.repetir" v-model="conta.repetirOcorrencias" style="max-width: 80px"/>
              <span class="m-l">vezes</span>
              <u-icon name="help" class="m-l font-14 text-blue-grey-5">
                <u-tooltip :offset="[2,2]">Quantas vezes este registro deve se repetir</u-tooltip>
              </u-icon>
            </e-col>
          </e-row>
          <e-row class="m-t m-b" mr>
            <e-col>
              <div style="border-top: #CCCCCC 1px solid"></div>
            </e-col>
          </e-row>
          <e-row mr>
            <e-col class="flex items-center">
              <label for="pago" class="no-select font-12 flex items-center">
                <input type="checkbox" v-model="conta.pago" id="pago">
                <span class="m-l-xs">Pago</span>
              </label>
            </e-col>
          </e-row>
          <e-row mr>
            <e-col>
              <erp-s-field :disabled="!conta.pago" label="Data pagamento">
                <datetime-input :disable="!conta.pago" input-class="app-input" date-type="date" date-format="##/##/####"
                                v-model.lazy="conta.dataPagamento"
                                simpleBorder/>
              </erp-s-field>
            </e-col>
            <e-col>
              <erp-s-field :disabled="!conta.pago" label="Descontos / Taxas">
                <erp-input :disable="!conta.pago" placeholder="R$" v-model.lazy="conta.descontos" v-money="money"/>
              </erp-s-field>
            </e-col>
            <e-col>
              <erp-s-field :disabled="!conta.pago" label="Juros / Multa">
                <erp-input :disable="!conta.pago" placeholder="R$" v-model.lazy="conta.jurosMulta" v-money="money"/>
              </erp-s-field>
            </e-col>
            <e-col>
              <erp-s-field :disabled="!conta.pago" label="Valor pago">
                <erp-input :disable="!conta.pago" placeholder="R$" v-model.lazy="conta.valorPago" v-money="money"/>
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row class="m-t-sm" mr>
            <e-col>
              <erp-s-field label="Observações">
                <textarea class="app-input input-textarea full-width" rows="4" v-model="conta.observacoes"/>
              </erp-s-field>
            </e-col>
          </e-row>
        </e-col>
        <e-col style="max-width: 250px; border-left: #D6DEE5 1px solid; min-height: 400px; padding-left: 20px">
          <e-row mr>
            <e-col>
              <erp-s-field :label="labelTipoPessoa">
                <fin-pessoa-input :tipo="tipoInt" :placeholder="'Digite um ' + labelTipoPessoa.toLowerCase()" v-model="conta.pessoa"/>
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row class="m-t-sm" mr>
            <e-col>
              <erp-s-field label="Forma de pagamento">
                <forma-pagamento-input v-model="conta.formaPagamento" />
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row class="m-t-sm" mr>
            <e-col>
              <erp-s-field label="Centro de custo">
                <centro-custo-input placeholder="Digite um centro de custo" v-model="conta.centroCusto"/>
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row class="m-t-sm" mr>
            <e-col>
              <erp-s-field label="Número do Doc">
                <erp-input v-model.lazy="conta.numeroDoc" />
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row class="m-t-sm" mr>
            <e-col>
              <erp-s-field label="Processo">
                <global-processo-input v-model="conta.processo" />
                <div v-if="conta.processo"><a @click="gotoProcesso(conta.processo && conta.processo.id ? conta.processo : {id: conta.processo})">Ver processo</a></div>
              </erp-s-field>
            </e-col>
          </e-row>
          <e-row class="m-t-sm" mr>
            <e-col>
              <div class="erp-s-field">
                <div class="erp-s-field-label">Anexos
                  <u-icon name="help" class="text-blue-grey-5 font-14">
                    <u-tooltip :offset="[4,4]">
                      Use o anexo de arquivos para manter comprovantes e arquivos digitais importantes relacionados.
                    </u-tooltip>
                  </u-icon>
                </div>
              </div>
              <div class="erp-s-field-content m-t-sm">
                <anexo-conta-input ref="uploader" :conta="conta"/>
              </div>
            </e-col>
          </e-row>
        </e-col>
      </e-row>
    </div>
    <div class="w-m-footer text-right footer-modern"
         style="justify-content: space-between !important; display: flex; flex-direction: row">
      <div class="text-left">

      </div>
      <div class="text-right">
        <u-btn @click="$uloc.window.close($root.wid)" label="Cancelar" no-caps
               :color="'white'"
               text-color="grey-8"
               class="b-radius-3px btn-white m-r-sm"/>
        <u-btn :loading="loading" type="button" @click="save('andClose')" :label="'Salvar ' + label" no-caps
               :color="'green'"
               class="b-radius-3px no-border-radius-right" />
        <u-btn icon="sort-down" icon-type="fa" no-caps class="p-btn-down normal b-radius-3px">
          <u-popover ref="popover" class="window-context-menu" style="width: 192px" anchor="bottom right" self="top right" :offset="[0, 0]">
            <div>
              <ul>
                <menu-options-item @click="save('andEdit')" label="Salvar e continuar editando" close  />
                <menu-options-item @click="save('andNew')" label="Salvar e criar novo" close  />
              </ul>
            </div>
          </u-popover>
        </u-btn>
      </div>
    </div>
  </form>
</template>

<script>
// @TODO: <V-2.2>: Tags
import {UTooltip, UPopover} from "uloc-vue"
import ERow from '@/components/layout/components/Row'
import {ErpInput, ErpSField, ErpSelect} from 'uloc-vue-plugin-erp'
import ECol from '@/components/layout/components/Col'
import MenuOptionsItem from '@/components/layout/context-menu/context-window-options-item'

import {newConta, updateConta} from "@/domain/financeiro/services"
//import CategoriaInput from "@/components/financeiro/components/input/CategoriaInput"
import BancoInput from "@/components/financeiro/components/input/BancoInput"
import DatetimeInput from "@/reuse/input/Datetime"
import mockConta from "@/domain/financeiro/helpers/mockConta"
import {convertRealToMoney, REAL_BRL} from "@/utils/money"
import {VMoney} from "v-money"
import {REPETIR} from "@/domain/financeiro/helpers/types"
import FinPessoaInput from "@/components/financeiro/components/input/PessoaInput"
import CentroCustoInput from "@/components/financeiro/components/input/CentroCustoInput"
import AnexoContaInput from "@/components/financeiro/components/input/AnexoContaInput"
import globalFinancialMixin from "@/components/financeiro/globalFinancialMixin"
import {datePtToEn} from "@/utils/date"
import FormaPagamentoInput from "@/components/financeiro/components/input/FormaPagamentoInput"
import {findConta} from "@/domain/financeiro/services"
import CategoriaHirerarquiaSelect from "@/components/financeiro/components/input/CategoriaHirerarquiaSelect";
import GlobalProcessoInput from "@/components/processos/components/processos/include/ProcessoInput"
import globalProcessoMixin from "@/components/processos/globalProcessoMixin"

export default {
  name: 'ContaWindowModern',
  provide: function () {
    return {
      container: this
    }
  },
  mixins: [globalFinancialMixin, globalProcessoMixin],
  directives: {money: VMoney},
  components: {
    GlobalProcessoInput,
    CategoriaHirerarquiaSelect,
    FormaPagamentoInput,
    AnexoContaInput,
    CentroCustoInput,
    FinPessoaInput,
    DatetimeInput,
    BancoInput,
    // CategoriaInput,
    // AutocompleteMultiple,
    // Autocomplete,
    // WindowLoading,
    ErpInput,
    ErpSField,
    ERow,
    ECol,
    ErpSelect,
    UTooltip,
    MenuOptionsItem,
    UPopover
    // TimerCloseWindow,
    // WindowSuccess,
    // ErpCheckbox
  },
  props: ['id', 'options', 'router', 'tipo', 'entidade', 'entidadeId', 'pessoa', 'extraRelations', 'tags'],
  data() {
    return {
      money: REAL_BRL,
      loading: false,
      success: false,
      status: '',
      preventBind: true,
      isPago: false,
      conta: this.getMock()
    }
  },
  mounted() {
    console.log(this.tipo)
    if (this.isEditing) {
      this.load()
    } else {
      this.preventBind = false
    }
  },
  watch: {
    'conta.pago' (v) {
      if (!v && this.isPago) {
        this.$uloc.dialog({
          title: 'Cancelar registro já pago',
          message: 'Esta conta já foi definida como paga e houve o lançamento contábil, ao definir como não pago um lançamento de estorno será realizado',
          ok: 'Sim, estornar pagamento',
          cancel: 'Não'
        }).then(() => {

        }).catch(() => {
          this.conta.pago = true
        })
      }
    }
  },
  computed: {
    tipoInt () {
      return this.isEditing ? this.conta.tipo : (this.tipo === 'r' ? 1 : 2)
    },
    isEditing () {
      return this.id || (this.conta && this.conta.id)
    },
    getTipoString () {
      if (this.conta && this.conta.id) {
        return Number(this.conta.tipo) === 1 ? 'r' : 'd'
      }
      return this.tipo
    },
    label() {
      let t = this.getTipoString
      return t === 'r' ? 'Recebimento' : 'Pagamento'
    },
    labelTipoPessoa() {
      return this.getTipoString === 'r' ? 'Cliente' : 'Fornecedor'
    },
    repetirTypes() {
      return Object.keys(REPETIR).map(k => {
        return {
          label: REPETIR[k].title,
          value: Number(k)
        }
      })
    }
  },
  methods: {
    getMock () {
      let mock = JSON.parse(JSON.stringify(mockConta))
      const hoje = this.$options.filters.formatDateNoIso(new Date(), 'dd/MM/yyyy')
      mock.dataPagamento = hoje
      mock.dataCompetencia = hoje
      mock.tipo = this.tipo === 'r' ? 1 : 2
      if (this.entidade && this.entidadeId) {
        mock.entidade = this.entidade
        mock.entidadeId = this.entidadeId
      }
      if (this.pessoa) {
        mock.pessoa = this.pessoa
      }
      if (this.extraRelations) {
        mock.extraRelations = this.extraRelations
      }
      if (this.tags) {
        mock.tags = this.tags
      }
      return mock
    },
    load() {
      this.loading = true
      findConta(this.isEditing)
          .then(response => {
            console.log(response)
            if (response.data.id) {
              this.conta.id = response.data.id
              if (Number(response.data.tipo) === 1) {
                this.$root.tipo = 'r'
              } else {
                this.$root.tipo = 'd'
              }
            }
            this.preventBind = true
            this.conta = Object.assign({}, this.conta, this.prepareToEdit(response.data))
            this.$nextTick(() => {
              setTimeout(() => {
                this.preventBind = false
              }, 1)
            })
            // this.task = response.data
            console.log(this.conta)
            this.loading = false
          })
          .catch(error => {
            this.alertApiError(error)
            this.loading = false
          })
    },
    prepareToSave() {
      const data = JSON.parse(JSON.stringify(this.conta))
      const valores = ['valor', 'valorPago', 'descontos', 'jurosMulta']
      valores.map(key => {
        data[key] = convertRealToMoney(data[key])
        if (!data[key]) {
          data[key] = null
        }
      })

      if (data.valor === null || data.valor === '') {
        data.valor = 0
      }

      if (data.dataCompetencia) {
        data.dataCompetencia = datePtToEn(data.dataCompetencia)
      }
      if (data.dataVencimento) {
        data.dataVencimento = datePtToEn(data.dataVencimento)
      }
      if (data.dataPagamento) {
        data.dataPagamento = datePtToEn(data.dataPagamento)
        if (!data.pago) {
          data.dataPagamento = null
        }
      }
      const relacoes = ['pessoa', 'centroCusto', 'conta', 'categoria', 'formaPagamento', 'status', 'processo']
      relacoes.map(key => {
        if (data[key] && data[key].id) {
          data[key] = data[key].id
        }
      })
      return data
    },
    prepareToEdit(data) {
      const valores = ['valor', 'valorPago', 'descontos', 'jurosMulta']
      valores.map(key => {
        data[key] = this.$options.filters.moeda(data[key])
        if (!data[key]) {
          data[key] = null
        }
      })
      const datas = ['dataCompetencia', 'dataVencimento', 'dataPagamento']
      datas.map(key => {
        if (data[key] && data[key].date) {
          data[key] = this.$options.filters.formatDate(data[key].date)
        }
      })
      if (data.categoria && data.categoria.id) {
        data.categoria = {
          ...data.categoria,
          label: data.categoria.descricao,
          value: data.categoria.id
        }
      }
      if (data.pago) {
        this.isPago = true
      }
      return data
    },
    save(type = 'andClose') {
      this.loading = true
      let data
      try {
        data = this.prepareToSave()
      } catch (e) {
        console.log(e)
        this.alertApiError(null, 'Erro de validação', null, `${e.message} Código L-${e.lineNumber}`)
        this.loading = false
        return
      }
      let method = newConta
      if (this.conta.id) {
        method = updateConta
      }
      method(data)
          .then(response => {
            this.loading = false
            console.log(response)
            const isEditing = this.isEditing
            this.conta.id = response.data.id
            this.$nextTick(() => {
              this.$refs.uploader && this.$refs.uploader.iniciaEnvios()
            })
            // this.$uloc.window.close(this.$root.wid)
            if (isEditing) {
              this.$uloc.window.emit(this.$root.wid, 'updated', response.data)
              this.success = true
              if (type === 'andEdit') {
                this.dg()
              } else {
                this.$uloc.notify({
                  color: 'positive',
                  message: `${this.label} com ID #${response.data.id} alterado.`,
                  position: 'bottom-right',
                  /*actions: [{
                    label: 'Visualizar',
                    handler: () => {
                      this.gotoPerson(response.data)
                    }
                  }]*/
                })
              }
            } else {
              this.$uloc.window.emit(this.$root.wid, 'created', response.data)
              this.$uloc.notify({
                color: 'black',
                message: `Novo ${this.label} com ID #${response.data.id} criado.`,
                position: 'bottom-right',
                /*actions: [{
                  label: 'Visualizar',
                  handler: () => {
                    this.gotoPerson(response.data)
                  }
                }]*/
              })
            }
            if ((!this.$refs.uploader || (this.$refs.uploader && !this.$refs.uploader.existsFilesToUpload)) && (type === 'andClose' || (this.entidade && this.entidadeId))) {
              this.$uloc.window.close(this.$root.wid)
            } else if (type === 'andNew') {
              this.preventBind = true
              this.conta = this.getMock()
              this.$nextTick(() => {
                this.preventBind = false
              })
            }
          })
          .catch(error => {
            console.log(error)
            this.loading = false
            this.alertApiError(error)
          })
    }
  }
}
</script>
